import React from 'react';
import { NoticeItems } from 'types/NoticeTypes';
import { BASE_UPLOADED_IMG_URL } from 'const/ConstBase';
import { useNavigate } from 'react-router-dom';
import { announcementDetailUrl, announcementType } from 'helper/helper';

import './NoticeItem.scss';

interface Props {
    item: NoticeItems;
}

export const NoticeItem: React.FC<Props> = (props: Props) => {
    const navigate = useNavigate();

    const handleClickItem = () => {
        let url = announcementDetailUrl(props.item.n_seq, props.item.n_title);

        navigate(url);
    };

    const cardType = announcementType(props.item.n_type);

    return (
        <>
            <div className='notice-item'>
                <div
                    className='notice-item-link'
                    onClick={() => handleClickItem()}
                >
                    <div
                        className='notice-item-image'
                        style={{
                            backgroundImage: `url(${BASE_UPLOADED_IMG_URL}${props.item.n_summary_image})`,
                        }}
                    />
                </div>

                <div className='notice-item-detail'>
                    <div className='card-category'>{cardType}</div>
                    <div
                        className='card-title'
                        onClick={() => handleClickItem()}
                    >
                        {props.item.n_title}
                    </div>
                    <div className='card-date'>{props.item.reg_date}</div>

                    <div className='card-summary-wrapper'>
                        <p className='card-summary'>
                            {props.item.n_list_summary}
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};
